import type { Copy } from "../types";

export const zh: Copy = {
    seo: {
      title: "车辆年龄计算器 | 按年份和月份查看车龄",
      description:
        "根据制造年份和可选月份查看车辆的准确年龄。在一个简洁工具中查看年、月、天、总天数和关键里程碑。",
      keywords: [
        "车辆年龄计算器",
        "车龄计算器",
        "车辆制造年份查询",
        "车辆制造月份查询",
        "我的车几岁",
        "按年份查车龄",
        "车辆年龄查询",
        "RC 车龄计算器",
        "按月份查车龄",
        "车辆日期计算器",
        "mParivahan 替代",
        "Parivahan 替代",
        "RTO 车辆年龄计算器",
        "车辆登记年龄",
        "车辆注册年龄",
      ],
      faq: [
        {
          question: "这个计算器做什么？",
          answer:
            "它根据所选制造年份和可选月份计算车辆的准确年龄，并显示年、月、天和里程碑信息。",
        },
        {
          question: "为什么有可选月份？",
          answer:
            "月份能让年龄计算更精确。如果不选择月份，系统会使用所选年份的 1 月。",
        },
        {
          question: "可以选择未来年份或月份吗？",
          answer:
            "不可以。未来年份会被禁止，当所选年份是当前年份时，未来月份也会被禁用。",
        },
      ],
    },
    headerTagline: "车辆工具",
    headerTitle: "车辆年龄计算器",
    reset: "重置",
    switchToLight: "切换到浅色模式",
    switchToDark: "切换到深色模式",
    languageLabel: "语言",
    languageEnglish: "英语",
    languageHindi: "印地语",
    heroEyebrow: "清晰查看车龄",
    heroTitle: "用于查看车辆年龄的简洁日期工具。",
    heroDescription:
      "选择制造年份。只有在需要更精确结果时才添加月份。",
    yearSelectLabel: "制造年份",
    monthSelectLabel: "制造月份",
    includeMonthLabel: "为更精确而包含具体月份",
    includeMonthNote: "如果不包含月份，计算将使用 1 月。",
    yearOnlyBadge: "仅年份",
    yearMonthBadge: "年份 + 月份",
    yearPlaceholder: "选择年份",
    monthPlaceholder: "选择月份",
    inputTitle: "制造年份",
    inputLabel: "制造年份",
    blockedDateNote: "不允许选择未来年份。",
    result: "结果",
    vehicleAgeLead: "您的车辆是",
    asOfToday: "截至今天",
    years: "年",
    months: "个月",
    days: "天",
    totalDays: (count) => `共 ${count.toLocaleString("en-IN")} 天`,
    ageLabels: { almostNew: "几乎新车", modern: "现代", mature: "成熟", classic: "经典" },
    estimatedValue: {
      high: "转售潜力高",
      healthy: "保值较好",
      moderate: "折旧中等",
      collector: "收藏价值可能提升",
    },
    maintenanceTitle: "保养",
    maintenance: {
      routine: "常规保养和原厂维护",
      watch: "注意刹车、液体和轮胎",
      plan: "安排易损件和检查计划",
      specialized: "专业保养变得更重要",
    },
    registrationTitle: "登记",
    registration: {
      collector: "某些地区可能适用收藏车待遇",
      classic: "某些地区可能适用经典车登记",
      standard: "可预期常规续期和地区检查",
      regular: "通常适用常规登记",
    },
    upcomingMilestoneTitle: "下一个里程碑",
    milestoneTimelineTitle: "里程碑时间线",
    milestoneRemaining: ({ label, days }) => `${label}还有 ${days.toLocaleString("zh-CN")} 天`,
    reached: "已达成",
    upcoming: "即将到来",
    allMilestonesReachedTitle: "所列里程碑已全部达成",
    allMilestonesReachedBody: "这辆车已经超过当前应用中显示的里程碑范围。",
    copySummary: "复制摘要",
    shareResult: "分享结果",
    resetMessage: "计算器已重置",
    summaryCopied: "摘要已复制到剪贴板",
    clipboardFailed: "无法访问剪贴板",
    emptyTitle: "选择制造年份以查看完整信息",
    emptyDescription:
      "选择年份后，你将看到准确年龄、总天数、保养说明、经典状态和里程碑时间。",
    shareTitle: "车辆年龄计算器",
    summary: ({ label, years, months, days, asOf }) =>
      `我的车制造于 ${label}，截至 ${asOf} 已有 ${years} 年 ${months} 个月 ${days} 天。`,
    milestones: {
      1: { label: "第 1 年", note: "适用于保修和保养规划。" },
      3: { label: "第 3 年", note: "常见于转售和价值变化阶段。" },
      5: { label: "第 5 年", note: "适合重新规划保养预算。" },
      10: { label: "第 10 年", note: "老化部件需要更多关注。" },
      15: { label: "第 15 年", note: "许多地区开始按经典车处理。" },
      25: { label: "第 25 年", note: "在某些市场更适合收藏和进口。" },
    },
  };
